import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { CMS } from "helpers/viewContent";
import { FORMAT_TEXT } from "helpers/common";
//imported
import * as Path from "routes/paths";
import { getCms_ } from "store/services/pagesService";
import ContentLoader_ from "helpers/ContentLoader_";
import * as actions from "store/actions/index.js";

const Listing = ({ dispatch }) => {
  const [listing, setListing] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function getData() {
    try {
      setIsLoading(true);
      dispatch(actions.persist_store({ loader:false}));
      let res = await dispatch(getCms_());
      setListing(res?.body);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
      
    }
  }
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
      <Helmet title={CMS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-table-large menu-icon"></i>
          </span>{" "}
          {CMS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.cms}>{CMS.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-6">Listing</div>
                  <div className="col-md-4"></div>
                  {/* <div className="col-md-2">
                            <Link to={Path.cms_form}><button type="button" class="btn btn-sm btn-gradient-primary"> + Add</button></Link>
                          </div> */}
                </div>
              </h4>
              <div class="table-responsive actionSticky">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> Title </th>
                      <th> Slug </th>
                      <th> Url </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                      <div className="loader-class">
                        <ContentLoader_ />
                      </div>
                    ) : (
                    <tbody>
                      {listing?.length > 0 &&
                        listing.map((list, i) => {
                          return (
                            <tr key={i}>
                              <td className="py-1">
                                {list?.title ? FORMAT_TEXT(list?.title) : "---"}
                              </td>
                              <td>{list?.slug} </td>
                              <td>
                                <a href={`${Path.cms_Page}/${list?.slug}`} target="_blank">
                                  View
                                </a>
                              </td>
                              <td>
                                <Link to={`${Path.cms_form}/${list?.slug}`}>
                                  <label
                                    class="btn btn-sm btn btn-gradient-warning"
                                    style={{ cursor: "pointer" }}
                                    title="Edit"
                                  >
                                    <i className="mdi mdi-grease-pencil"></i>
                                  </label>
                                </Link>
                                &nbsp;&nbsp;
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  )}
                </table>
              </div>
              {!isLoading && listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    loader: state.Pages.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
